import { Controller } from 'stimulus'
import Hammer from 'hammerjs'
import Rails from '@rails/ujs'
import { gsap, ScrollToPlugin } from "gsap/all";
gsap.registerPlugin(ScrollToPlugin);

export default class extends Controller {
  static targets = [ 'swipe', 'slide', 'dot', 'nav', 'dotContainer' ]

  connect() {
    window.requestAnimationFrame(() => {
      this.animationClasses = ['slideOutLeft', 'slideOutRight', 'slideInLeft', 'slideInRight']
      if (this.slide) this.loadCurrentSlide()
      if (this.hasDotTarget) {
        this.dot.style.opacity = 1
        this.dot.style.transform = 'scale(1.35)'
        if (this.hasDotContainerTarget) this.dotContainerTarget.scrollLeft = this.dotScrollLeft
        Hammer(this.swipeTarget).on('swipeleft', this.next)
        Hammer(this.swipeTarget).on('swiperight', this.previous)
      }
    })
  }

  disconnect() {
    if (this.hasDotTarget) {
      this.slide.classList.remove(...this.animationClasses)
      Hammer(this.swipeTarget).off('swipeleft', this.next)
      Hammer(this.swipeTarget).off('swiperight', this.previous)
    }
  }

  jump(event) {
    let i = this.dotTargets.indexOf(event.currentTarget)
    if (i > this.index) {
      this.next(event, i)
    } else if (i < this.index) {
      this.previous(event, i)
    }
  }

  next = (event, i) => {
    if (event.preventDefault) event.preventDefault()
    if (event.stopPropagation) event.stopPropagation()
    this._animateCurrentSlideWith('slideOutLeft')
    this.index = i || this.index + 1
    this._animateCurrentSlideWith('slideInRight')
  }

  previous = (event, i) => {
    if (event.preventDefault) event.preventDefault()
    if (event.stopPropagation) event.stopPropagation()
    this._animateCurrentSlideWith('slideOutRight')
    this.index = i || this.index - 1
    this._animateCurrentSlideWith('slideInLeft')
  }

  _animateCurrentSlideWith(klass) {
    const currentSlide = this.slide
    currentSlide.classList.remove(...this.animationClasses)
    currentSlide.classList.add(klass)
  }

  _highlightCurrentDot() {
    this.dot.style.opacity = 1
    this.dot.style.transform = 'scale(1.35)'
    this._scrollToDot()
  }

  _scrollToDot() {
    if (this.hasDotContainerTarget) {
      gsap.to(this.dotContainerTarget, 0.3, { scrollTo: { x: this.dotScrollLeft } })
    }
  }

  _lowlightCurrentDot() {
    this.dot.style.opacity = null
    this.dot.style.transform = 'scale(1)'
  }

  loadCurrentSlide() {
    this.slide.classList.remove('dn')
    if (this.slide.dataset.src != '_destroy' && this.slide.dataset.src) {
      this.slide.style.backgroundImage = 'url(' + this.slide.dataset.src + ')'
    }
    if (this.avatarController) {
      this.avatarController.setSrc(this.slide.dataset.src)
    }
  }

  get avatarController() {
    return this.application.getControllerForElementAndIdentifier(this.element, 'avatar')
  }

  get dotScrollLeft() {
    return this.dot.getBoundingClientRect().left - this.dotContainerTarget.getBoundingClientRect().left + this.dotContainerTarget.scrollLeft - (this.dotContainerTarget.getBoundingClientRect().width/2)
  }

  get dot() {
    return this.dotTargets[this.index % this.slideTargets.length]
  }

  get slide() {
    return this.slideTargets[this.index % this.slideTargets.length]
  }

  get index() {
    return parseInt(this.data.get('index'))
  }

  set index(value) {
    if (value < 0) {
      value = this.slideTargets.length - 1
    }
    this._lowlightCurrentDot()
    this.data.set('index', value)
    this.loadCurrentSlide()
    this._highlightCurrentDot()
  }
}
